module.exports = __webpack_public_path__ + "static/media/tipoConsulta__EstrellaRecomendada.9250b621.svg";